import React from "react";
import ReactDOM from "react-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { Link } from "react-router-dom";
import { t } from "i18next";
const Logout = () => {
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const setLogoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLogoutShow;
  });
  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          "-webkit-box-pack": "center",
          "-webkit-justify-content": "center",
          "-ms-flex-pack": "center",
          "justify-content": "center",
          "-webkit-align-items": "center",
          "-webkit-box-align": "center",
          "-ms-flex-align": "center",
          "align-items": "center",
        }}
      >
        <div
          id="cdk-overlay-2"
          className="cdk-overlay-pane dialog-panel"
          style={{ position: "static" }}
        >
          <app-dialog _nghost-serverapp-c33280995>
            <div _ngcontent-serverapp-c33280995 className="popup" id="dialog-2">
              <div
                _ngcontent-serverapp-c33280995
                className="popup__header"
              ></div>
              <div _ngcontent-serverapp-c33280995 className="popup__content">
                <app-logout-check
                  _nghost-serverapp-c395440154
                  className="ng-tns-c395440154-12 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c395440154
                    className="pop-wrap promotion-pop new ng-tns-c395440154-12 ng-trigger ng-trigger-popWrapTriggerAni show ani ng-star-inserted"
                  >
                    <Link to='/'
                      onClick={() => setLogoutShow(false)}
                      _ngcontent-serverapp-c395440154
                      className="btn-close ng-tns-c395440154-12"
                      style={{
                        "mask-image":
                          'url("/assets/Other/icon-close.svg")',
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c395440154
                      className="pop-title ng-tns-c395440154-12"
                    >
                      <h3
                        _ngcontent-serverapp-c395440154
                        className="ng-tns-c395440154-12"
                      >
                        {t('LogOut')}
                      </h3>
                    </div>
                    <div
                      _ngcontent-serverapp-c395440154
                      className="pop-inner content-style ng-tns-c395440154-12"
                    >
                      <div
                        _ngcontent-serverapp-c395440154
                        className="ng-tns-c395440154-12"
                      >
                        <p>
                          {t('BeforeLogin')}
                        </p>
                      </div>
                      <div
                        _ngcontent-serverapp-c395440154
                        className="btn-box ng-tns-c395440154-12"
                      >
                        <div style={{background:"#364848"}}
                          onClick={() => setLogoutShow(false)}
                          _ngcontent-serverapp-c395440154
                          onclick
                          className="button btn-secondary ng-tns-c395440154-12"
                        >
                          <a
                            _ngcontent-serverapp-c395440154
                            className="ng-tns-c395440154-12"
                          >
                            {t("Cancel")}
                          </a>
                        </div>
                        <div
                          onClick={() => logoutUser()}
                          _ngcontent-serverapp-c395440154
                          onclick
                          className="button btn-primary ng-tns-c395440154-12"
                        >
                          <a
                            _ngcontent-serverapp-c395440154
                            className="ng-tns-c395440154-12"
                          >
                            {t("LogOut")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c395440154
                    className="pop-bg ng-trigger ng-trigger-popBgTriggerAni ng-tns-c395440154-12 ng-star-inserted"
                    style={{ display: "block" }}
                  />
                </app-logout-check>
              </div>
            </div>
          </app-dialog>
        </div>
      </div>
    </div>,
    document.getElementById("overlay")
  );
};

export default Logout;
